import * as mt from './mutation-types';
import { Results } from './types';
import { ScoreHistogramDTO, AreaHistogramDTO, HarvestResultTableDTO } from '@/api/results/types';

export default {
  [mt.FETCHING_SCORE_HISTOGRAM] (state: Results) {
    state.statusScoreHistogram = "fetching:score-histogram";
  },
  [mt.FETCH_SCORE_HISTOGRAM_SUCCESS] (state: Results, histograms: ScoreHistogramDTO[]) {
    state.scoreHistogramContext = histograms;
    state.statusScoreHistogram = "fetch:score-histogram"
  },
  [mt.FETCH_SCORE_HISTOGRAM_FAILED] (state: Results) {
    state.scoreHistogramContext = null;
    state.statusScoreHistogram = "fail:score-histogram"
  },
  [mt.FETCHING_AREA_HISTOGRAM] (state: Results) {
    state.statusAreaHistogram = "fetching:area-histogram";
  },
  [mt.FETCH_AREA_HISTOGRAM_SUCCESS] (state: Results, histograms: AreaHistogramDTO[]) {
    state.areaHistogramContext = histograms;
    state.statusAreaHistogram = "fetch:area-histogram"
  },
  [mt.FETCH_AREA_HISTOGRAM_FAILED] (state: Results) {
    state.areaHistogramContext = null;
    state.statusAreaHistogram = "fail:area-histogram"
  },
  [mt.FETCH_HARVEST_RESULT_REQUEST] (state: Results) {
    state.statusHarvestResult = "fetching:harvest-result";
  },
  [mt.FETCH_HARVEST_RESULT_SUCCESS] (state: Results, dto: HarvestResultTableDTO[]) {
    state.harvestResultContext = dto;
    state.statusHarvestResult = "fetch:harvest-result"
  },
  [mt.FETCH_HARVEST_RESULT_FAILED] (state: Results) {
    state.harvestResultContext = null;
    state.statusHarvestResult = "fail:harvest-result"
  },
  
  
};
